export const GET_ROBOT_DATA = 'GET_ROBOT_DATA';
export const RESET_ROBOT_DATA = 'RESET_ROBOT_DATA';
export const GET_UNREAD_ROBOT_COUNT = 'GET_UNREAD_ROBOT_COUNT';
export const SET_UNREAD_ROBOT_COUNT = 'SET_UNREAD_ROBOT_COUNT';
export const GET_ROBOT_DETAILS = 'GET_ROBOT_DETAILS';
